module.exports = "/images/vendor/desiigner-svg/svg/specials/sustainable.svg?442c0dc6a138f4d554de964eb1c5ad2c";